import Observer from '../models/Observer';
/**
 * model class of configuration
 */
class ConfigurationModel extends Observer
{
    /**
     * iso string of using language
     * @type {string}
     */
    Language = "";
    /**
     * display string for iso
     * @type {string}
     */
    LanguageDisplay = "";
    /**
     * names of supported languages
     * @type {Array}
     */
    Languages = [];
    /**
     * filename of using theme
     * @type {string}
     */
    Theme = "";
    /**
     * display string of using theme
     * @type {string}
     */
    ThemeDisplay = "";
    /**
     * names of supported themes
     * @type {Array}
     */
    Themes = [];

    constructor(observer)
    {
        super(observer);
        this.Language = localStorage.getItem('vas_language');
        this.Theme = localStorage.getItem('vas_design');

        if(!localStorage.getItem('vas_design')) {
            localStorage.setItem('vas_design',"Standard-Theme");
        }

        let supportedLanguages = require('../i18n/languages.json');
        let supportedThemes = require('../designs/designs.json');

        let me = this;

        supportedLanguages.Languages.forEach(function(value){
            me.Languages.push(value.Name);
            
            if(me.Language === value.Iso)
                {me.LanguageDisplay = value.Name;
                }
        });

        supportedThemes.Designs.forEach(function(value){
            me.Themes.push(value.Name);

            if(me.Theme === value.Name)
                {me.ThemeDisplay = value.Name;}
        });
    }
    SaveConfiguration()
    {
        let supportedLanguages = require('../i18n/languages.json');
        let supportedThemes = require('../designs/designs.json');

        let me = this;
        
        supportedLanguages.Languages.forEach(function(value)
        {
            if(me.LanguageDisplay === value.Name)
               localStorage.setItem("vas_language", value.Iso);
        });

        supportedThemes.Designs.forEach(function(value)
        {
            if(me.ThemeDisplay === value.Name)
                localStorage.setItem("vas_design",value.Name);
        });
    }
}
export default ConfigurationModel;